import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { AppRoutingModule } from 'src/app/app-routing.module';
import { MaterialModule } from 'src/app/material.module';
import { DirectivesModule } from '../directives/module';
import { AuditLogApiService } from './services/audit-log-api-service';

@NgModule({
  imports: [CommonModule, MaterialModule, DirectivesModule, AppRoutingModule],
  declarations: [],
  providers: [AuditLogApiService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AuditLogModule {}
